module.exports = __webpack_public_path__ + "static/media/sync-red.b6833746.svg";